import { useAdicionarPapel } from "./use-adicionar-papel";
import { AdicionarPapelView } from "./view-adicionar-papel";
import type { AdicionarPapelProps } from "./types-adicionar-papel";

export function AdicionarPapel(props: AdicionarPapelProps) {
  const vm = useAdicionarPapel(props);

  return <AdicionarPapelView {...props} {...vm} />;
}

export type * from "./types-adicionar-papel";
